import React, { useState } from 'react';
import { Tooltip,  Input } from 'antd';
import Image from 'next/image';
import { WidgetProps } from '@rjsf/utils';


const CheckboxIconWidget = (props: WidgetProps) => {
    const {
        id,
        value,
        disabled,
        readonly,
        onChange,
        onBlur,
        onFocus,
        schema,
        placeholder,
    } = props;

    // For boolean fields, use the form value; for other types, manage local state
    const isBoolean = schema.type === "boolean";
    const [isChecked, setIsChecked] = useState(isBoolean ? Boolean(value) : false);

    // Update local state when form value changes (for boolean fields)
    React.useEffect(() => {
        if (isBoolean) {
            setIsChecked(Boolean(value));
        }
    }, [value, isBoolean]);

    const getInputType = () => {
        if (schema.type === "number" || schema.type === "integer") {
            return "number";
        }
        return "text";
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        console.log('i handle change', e.target.value)
        const newValue = e.target.value === "" ? undefined : e.target.value;
        onChange(newValue);
    };

    const handleCheckboxToggle = () => {
        if (disabled || readonly) {
            return; // Don't allow interaction when disabled or readonly
        }
        
        if (isBoolean) {
            const newCheckedState = !isChecked;
            setIsChecked(newCheckedState);
            onChange(newCheckedState);
        } else {
            setIsChecked(!isChecked);
        }
    };

    const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
        if (onBlur) {
            onBlur(id, e.target.value);
        }
    };

    const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
        if (onFocus) {
            onFocus(id, e.target.value);
        }
    };


    return (
        <div className='flex flex-row items-center hnn_checkboxwithinput'>
            <Tooltip key={id} placement="bottom" title={<div dangerouslySetInnerHTML={{ __html: schema.tooltip }} />} color="var(--primary-100)">
                <div className='checkboxlist__icon'>
                    <div 
                        className={`rounded p-1 flex justify-center items-center w-7 h-7 ${
                            disabled || readonly 
                                ? 'cursor-not-allowed bg-gray-100' 
                                : 'cursor-pointer'
                        } ${
                            isBoolean 
                                ? isChecked 
                                    ? disabled || readonly 
                                        ? 'bg-gray-300' 
                                        : 'bg-primary_900'
                                    : disabled || readonly 
                                        ? 'bg-gray-100' 
                                        : 'bg-primary_200 hover:bg-secondary_100'
                                : ''
                        }`} 
                        onClick={handleCheckboxToggle}
                    >
                        <div className={
                            isBoolean 
                                ? isChecked 
                                    ? disabled || readonly 
                                        ? 'svg-gray'
                                        : 'svg-white'
                                    : disabled || readonly 
                                        ? 'svg-gray' 
                                        : 'svg-dark-gray'
                                : ''
                        }>
                            <Image
                                src={`/icons/${schema.iconPath}`}
                                alt={`${schema.iconPath} image`}
                                width={20}
                                height={20}
                            />
                        </div>
                        {!isBoolean && (
                            <span className='checkboxlist__checkbox hidden'>
                                <input
                                    type="checkbox"
                                    id={id}
                                    checked={isChecked}
                                    readOnly
                                />
                            </span>
                        )}
                    </div>
                </div>
            </Tooltip>

            <div data-measures-overview={false}>
                {!isBoolean && (
                    <div className='flex flex-row items-center gap-2'>
                        <Input
                            id={id}
                            type={getInputType()}
                            value={value || 0}
                            disabled={disabled}
                            readOnly={readonly}
                            placeholder={placeholder}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            onFocus={handleFocus}
                            style={readonly || disabled ? { 
                                borderWidth: '1px', 
                                borderColor: 'transparent', 
                                backgroundColor: 'var(--disabled-background)', 
                                color: 'gray',
                                flex: 1 
                            } : { flex: 1 }}
                        />
                        {schema.unit && (
                            <span style={{
                                fontSize: "10px",
                                whiteSpace: "nowrap",
                                minWidth: "fit-content"
                            }}>
                                {String(schema.unit)}
                            </span>
                        )}
                    </div>
                )}
            </div>

        </div>
    );
};

export default CheckboxIconWidget;